import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { StyleSheet, css } from 'aphrodite';

import { ReportBox, Flexbox, Font, Text } from './Styles'
import ScenarioList from './models/ScenarioList';
import Image from './Image';
import PrimaryButton from './PrimaryButton';
import ShareIcons from './ShareIcons';

import Locale from './models/Locale';

const styles = StyleSheet.create({
  link: {
    textDecoration: 'none',
    cursor: 'pointer',
  }
});

class Winner extends Component {
  render() {
    let gameComplete = this.props.scenario.level === ScenarioList.length - 1;

    return(
      <div className={css(Flexbox.column, Flexbox.axisStart, Flexbox.crossCenter)}>
        <div className={css(Flexbox.column, Flexbox.axisStart, Flexbox.crossCenter, ReportBox.container)}>
          <Image extraStyles={ReportBox.topImage} filename={gameComplete? "winner.png" : "unlocked.png"} />
          <div className={css(Font.heading, Flexbox.centeredItem, Text.heading)}>
            <p>{this.props.effectiveAction.description}</p>
          </div>
          <div className={css(Flexbox.grow, Flexbox.centeredItem, Text.textBlock)}>
            <p>{this.props.event.rationaleForAction(this.props.effectiveAction)}</p>
          </div>
          {gameComplete &&
            <div className={css(Font.heading, Flexbox.centeredItem, Text.heading)}>{Locale.localized("Congratulations! You have won the game!")}</div>
          }
          {!gameComplete &&
            <div className={css(Font.heading, Flexbox.centeredItem, Text.heading)}>{Locale.localized("Congratulations! You have unlocked the next level!")}</div>
          }
          { window.location.protocol !== 'file:' &&
            <Link className={css(styles.link)} to={`/checklists/${this.props.scenario.path}_${Locale.locale()}.pdf`} target="_blank">
              <div className={css(Font.centeredItem, Text.textBlock)}>{Locale.localized('Click here to get the checklist of preparedness actions for') + " " + this.props.scenario.name}</div>
            </Link>
          }
          { window.location.protocol !== 'file:' && gameComplete &&
            <Link className={css(styles.link)} to={`/checklists/all_${Locale.locale()}.pdf`} target="_blank">
              <div className={css(Font.centeredItem, Text.textBlock)}>{Locale.localized('Review and share the activities on this checklist to help your community become more prepared! Click here to get the full checklist including actions from all levels of the game.') + " " + this.props.scenario.name}</div>
            </Link>
          }
          <ShareIcons title={`${Locale.localized("I just beat")} ${this.props.scenario.name} ${Locale.localized("in the Get Ready game! Can you do better? Play today!")}`} />
          <Link to="/cities">
            {!gameComplete &&
              <PrimaryButton>{Locale.localized("Play Next Level")}</PrimaryButton>
            }
            {gameComplete &&
              <PrimaryButton>{Locale.localized("Play Again")}</PrimaryButton>
            }
          </Link>
        </div>
      </div>
    );
  }
}

export default Winner;



// WEBPACK FOOTER //
// ./src/Winner.js